import { createStructuredSelector } from "reselect";
import {
    FORM_KPI_LCR_LIST,
    FORM_KPI_LCR_LIST_SUCCESS,
    FORM_KPI_LCR_LIST_ERROR,
    FORM_KPI_LCR_PAGE_SET,
    FORM_KPI_LCR_SEARCH_SET,
    FORM_KPI_LCR_SEARCH_CHANGE,
    FORM_KPI_LCR_ADD_MODAL_SET,
    FORM_KPI_LCR_ADD,
    FORM_KPI_LCR_ADD_SUCCESS,
    FORM_KPI_LCR_ADD_ERROR,
    FORM_KPI_LCR_ADD_CHANGE,
    FORM_KPI_LCR_ADD_SET,
    FORM_KPI_LCR_PROJECT,
    FORM_KPI_LCR_PROJECT_SUCCESS,
    FORM_KPI_LCR_PROJECT_ERROR,
    FORM_KPI_LCR_ARTICLE_TYPE,
    FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS,
    FORM_KPI_LCR_ARTICLE_TYPE_ERROR,
    FORM_KPI_LCR_ACQUISITION_TYPE,
    FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS,
    FORM_KPI_LCR_ACQUISITION_TYPE_ERROR,
    FORM_KPI_LCR_CONTRACT_TYPE,
    FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS,
    FORM_KPI_LCR_CONTRACT_TYPE_ERROR,
    FORM_KPI_LCR_COUNTRY_PROJECT,
    FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS,
    FORM_KPI_LCR_COUNTRY_PROJECT_ERROR,
    FORM_KPI_LCR_COUNTRY_LIST,
    FORM_KPI_LCR_COUNTRY_LIST_SUCCESS,
    FORM_KPI_LCR_COUNTRY_LIST_ERROR
} from "../actions";

export const NAME = 'formKpiLcr';

export const FormKpiLcrList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: FORM_KPI_LCR_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const FormKpiLcrListSuccess = (data) => ({
    type: FORM_KPI_LCR_LIST_SUCCESS,
    payload: data
});

export const FormKpiLcrListError = (error) => ({
    type: FORM_KPI_LCR_LIST_ERROR,
    payload: error
});

export const FormKpiLcrPageSet = (data) => ({
    type: FORM_KPI_LCR_PAGE_SET,
    payload: data
});

export const FormKpiLcrSearchSet = (data) => ({
    type: FORM_KPI_LCR_SEARCH_SET,
    payload: data
});

export const FormKpiLcrSearchChangeSet = (data) => ({
    type: FORM_KPI_LCR_SEARCH_CHANGE,
    payload: data
});

export const FormKpiLcrAddModalSet = (data) => ({
    type: FORM_KPI_LCR_ADD_MODAL_SET,
    payload: data
});

export const FormKpiLcrAdd = (page, num_page, orderBy, filters, data) => ({
    type: FORM_KPI_LCR_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const FormKpiLcrAddSuccess = (message) => ({
    type: FORM_KPI_LCR_ADD_SUCCESS,
    payload: message
});

export const FormKpiLcrAddError = (error) => ({
    type: FORM_KPI_LCR_ADD_ERROR,
    payload: error
});

export const FormKpiLcrAddChangeSet = (data) => ({
    type: FORM_KPI_LCR_ADD_CHANGE,
    payload: data
});

export const FormKpiLcrAddSet = (data) => ({
    type: FORM_KPI_LCR_ADD_SET,
    payload: data
});

export const FormKpiLcrProject = (filters) => ({
    type: FORM_KPI_LCR_PROJECT,
    payload: { filters: filters }
});

export const FormKpiLcrProjectSuccess = (data) => ({
    type: FORM_KPI_LCR_PROJECT_SUCCESS,
    payload: data
});

export const FormKpiLcrProjectError = (error) => ({
    type: FORM_KPI_LCR_PROJECT_ERROR,
    payload: error
});

export const FormKpiLcrArticleType = (filters) => ({
    type: FORM_KPI_LCR_ARTICLE_TYPE,
    payload: { filters: filters }
});

export const FormKpiLcrArticleTypeSuccess = (data) => ({
    type: FORM_KPI_LCR_ARTICLE_TYPE_SUCCESS,
    payload: data
});

export const FormKpiLcrArticleTypeError = (error) => ({
    type: FORM_KPI_LCR_ARTICLE_TYPE_ERROR,
    payload: error
});

export const FormKpiLcrAcquisitionType = (filters) => ({
    type: FORM_KPI_LCR_ACQUISITION_TYPE,
    payload: { filters: filters }
});

export const FormKpiLcrAcquisitionTypeSuccess = (data) => ({
    type: FORM_KPI_LCR_ACQUISITION_TYPE_SUCCESS,
    payload: data
});

export const FormKpiLcrAcquisitionTypeError = (error) => ({
    type: FORM_KPI_LCR_ACQUISITION_TYPE_ERROR,
    payload: error
});

export const FormKpiLcrContractType = (filters) => ({
    type: FORM_KPI_LCR_CONTRACT_TYPE,
    payload: { filters: filters }
});

export const FormKpiLcrContractTypeSuccess = (data) => ({
    type: FORM_KPI_LCR_CONTRACT_TYPE_SUCCESS,
    payload: data
});

export const FormKpiLcrContractTypeError = (error) => ({
    type: FORM_KPI_LCR_CONTRACT_TYPE_ERROR,
    payload: error
});

export const FormKpiLcrCountryProject = (filters) => ({
    type: FORM_KPI_LCR_COUNTRY_PROJECT,
    payload: { filters: filters }
});

export const FormKpiLcrCountryProjectSuccess = (data) => ({
    type: FORM_KPI_LCR_COUNTRY_PROJECT_SUCCESS,
    payload: data
});

export const FormKpiLcrCountryProjectError = (error) => ({
    type: FORM_KPI_LCR_COUNTRY_PROJECT_ERROR,
    payload: error
});

export const FormKpiLcrCountryList = (filters) => ({
    type: FORM_KPI_LCR_COUNTRY_LIST,
    payload: { filters: filters }
});

export const FormKpiLcrCountryListSuccess = (data) => ({
    type: FORM_KPI_LCR_COUNTRY_LIST_SUCCESS,
    payload: data
});

export const FormKpiLcrCountryListError = (error) => ({
    type: FORM_KPI_LCR_COUNTRY_LIST_ERROR,
    payload: error
});


const formKpiLcr = (state) => state[NAME];

export const FormKpiLcrSelector = createStructuredSelector({
    formKpiLcr
})
